import { render, staticRenderFns } from "./ProductTiersInput.vue?vue&type=template&id=7a8bc311&scoped=true&lang=pug&"
import script from "./ProductTiersInput.vue?vue&type=script&lang=js&"
export * from "./ProductTiersInput.vue?vue&type=script&lang=js&"
import style0 from "./ProductTiersInput.vue?vue&type=style&index=0&id=7a8bc311&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8bc311",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
